import { Link } from "react-router-dom";
import { Button } from "../components/ui";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-5 text-center">
      <p className="font-graphik text-7xl text-white">404</p>
      <h1 className="text-2xl font-semibold text-white">Page not found</h1>
      <p className="max-w-md text-wandor-muted">
        The page you are looking for does not exist or may have been moved.
      </p>
      <Link to="/">
        <Button>Back to the event portal</Button>
      </Link>
    </div>
  );
}
